import React, {Component} from 'react';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom'
import flow from 'lodash/flow'
import {connect} from 'react-redux'

import withStyles from 'material-ui/styles/withStyles'

import global from '../style/global'
import Login from './Login'
import Callback from './Callback'
import PageLoading from './PageLoading'
import Loadable from 'react-loadable'
import {getStore, injectAsyncReducer} from '../store'

import {getAuthenticated, getPermissions, getProfileLoaded, getRole} from '../selectors'
import {hasPermission} from "../utils/permissions";
import {PERMISSIONS} from "../models/enums";


const VegetationRoutes = Loadable({
    loader: () => import('../modules/vegetation' /* webpackChunkName: 'vegetation' */),
    loading: PageLoading,
    render(loaded, props) {
        if(loaded.default.reducers)
            injectAsyncReducer(getStore(), 'vegetation', loaded.default.reducers);
        let Component = loaded.default.Routes;
        return <Component {...props}/>;
    }
});

const ViewReviewRoutes = Loadable({
    loader: () => import('../modules/inspectionReview' /* webpackChunkName: 'viewreview' */),
    loading: PageLoading,
    render(loaded, props) {
        if(loaded.default.reducers)
            injectAsyncReducer(getStore(),'review', loaded.default.reducers);
        let Component = loaded.default.Routes;
        return <Component {...props}/>;
    }
});

const UsersRoute = Loadable({
    loader: () => import('../modules/users' /* webpackChunkName: 'users' */),
    loading: PageLoading,
    render(loaded, props) {
        if(loaded.default.reducers)
            injectAsyncReducer(getStore(), 'users', loaded.default.reducers);
        let Component = loaded.default.Routes;
        return <Component {...props}/>;
    }
});


const FormsRoutes = Loadable({
    loader: () => import('../modules/forms' /* webpackChunkName: 'forms' */),
    loading: PageLoading,
    render(loaded, props) {
        if(loaded.default.reducers)
            injectAsyncReducer(getStore(), 'forms', loaded.default.reducers);
        let Component = loaded.default.Routes;
        return <Component {...props}/>;
    }
});

const HomeRoutes = ({profileLoaded, role, permissions, location}) => {
    return (<Switch>
    <Route path="/" render={() => {
        if(!profileLoaded)
            return <PageLoading showSpinner={true}/>;

        const isFormUser = !hasPermission(permissions, PERMISSIONS.ViewSiteInspection) &&
            hasPermission(permissions, PERMISSIONS.ViewForms);

        if(isFormUser && location.pathname.indexOf('/forms') < 0) {
            return <Redirect to="/forms"/>
        }

        return <Switch>
            <Route path="/users" component={UsersRoute}/>
            <Route path="/viewreview" component={ViewReviewRoutes}/>
            <Route path="/forms" component={FormsRoutes}/>
            <Route path="/" component={isFormUser ? FormsRoutes : VegetationRoutes}/>
        </Switch>
    }
    }/>
    </Switch>)
};

class Routes extends Component {
    render() {
        const {authenticated, profileLoaded, role, permissions, location} = this.props;

        const canAddInspection = hasPermission(permissions, PERMISSIONS.AddSiteInspection);
        const landingUrl = canAddInspection ? '/' : '/search';
        return (<Switch>
                    <Route exact path="/login" render={(props) => {
                        if(authenticated)
                            return <Redirect to={landingUrl}/>;
                        else
                            return <Login {...props} />}
                    }/>
                <Route exact path="/return" render={() => {
                    if (authenticated)
                        return <Redirect to={landingUrl}/>;
                    else
                        return <Redirect to={'/login'}/>
                }
                }/>
                    <Route exact path="/callback" render={(props) => <Callback {...props} />} />
                    <Route path="/" render={() => {
                        if (!authenticated)
                            return <Redirect to="/login"/>;
                        return (
                            <HomeRoutes
                                profileLoaded={profileLoaded}
                                role={role}
                                permissions={permissions}
                                location={location}
                            />
                        )
                    }}/>
                    <Route path="*" render={() => <h1>404: Not Found</h1>}/>
                </Switch>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        authenticated: getAuthenticated(state),
        profileLoaded: getProfileLoaded(state),
        role: getRole(state),
        permissions: getPermissions(state)
    }
};

const styles = theme => ({
    ...global(theme)
});

export default flow([
    connect(mapStateToProps),
    withStyles(styles),
    withRouter
])(Routes);




// WEBPACK FOOTER //
// ./src/components/Routes.js